// 앱 공지 — Firestore config/announcement 하나 (공개 읽기). 쓰는 법과 필드는
// functions/announcement.js 맨 위. 앱 빌드 없이 띄우고 내린다.
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase.js';
import { getPlatform, isNativeApp } from './platform-service.js';

const TTL = 5 * 60 * 1000; // 공지는 급히 내릴 일이 있어 짧게
const SEEN_PREFIX = 'archelier_announce_seen_';
let cache = { at: 0, val: null };

async function load() {
  if (Date.now() - cache.at < TTL) return cache.val;
  try {
    const snap = await getDoc(doc(db, 'config', 'announcement'));
    cache = { at: Date.now(), val: snap.exists() ? snap.data() : null };
  } catch (e) {
    console.warn('announcement load failed:', e?.message);
    cache = { at: Date.now(), val: null };
  }
  return cache.val;
}

let versionP = null;
function appVersion() {
  if (!isNativeApp()) return Promise.resolve(null);
  versionP ||= import('@capacitor/app')
    .then(({ App }) => App.getInfo())
    .then((i) => i.version || null)
    .catch(() => null);
  return versionP;
}

// '2.3.0' 끼리 비교. 숫자 아닌 조각은 0.
function cmpVersion(a, b) {
  const pa = String(a).split('.').map((n) => parseInt(n, 10) || 0);
  const pb = String(b).split('.').map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i += 1) {
    const d = (pa[i] || 0) - (pb[i] || 0);
    if (d) return d;
  }
  return 0;
}

export function pickText(map, lang) {
  if (!map || typeof map !== 'object') return '';
  return map[lang] || map.en || Object.values(map).find((v) => typeof v === 'string') || '';
}

function seen(id) {
  try { return !!localStorage.getItem(SEEN_PREFIX + id); } catch { return false; }
}
export function markAnnouncementSeen(id) {
  try { localStorage.setItem(SEEN_PREFIX + id, '1'); } catch { /* ignore */ }
}

// 지금 이 사람에게 띄울 공지, 없으면 null.
export async function currentAnnouncement({ signedIn }) {
  const a = await load();
  if (!a || a.active !== true || !a.id || !a.title) return null;
  const id = String(a.id);
  if (seen(id)) return null;
  const now = Date.now();
  if (a.from && Date.parse(a.from) > now) return null;
  if (a.until && Date.parse(a.until) < now) return null;
  if (Array.isArray(a.platforms) && a.platforms.length && !a.platforms.includes(getPlatform())) return null;
  if (a.audience === 'signedIn' && !signedIn) return null;
  if (a.audience === 'guest' && signedIn) return null;
  if (a.maxVersion) {
    const v = await appVersion();
    if (!v || cmpVersion(v, a.maxVersion) > 0) return null;
  }
  return { ...a, id };
}
